import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import { Formik, Form } from "formik";
import { Select } from "view/component/FormFormik";
import { showLoading, toast } from "view/component/Alert";
import apiService from "apiService";
const ModalWa = (props) => {
  const [visit, setVisit] = useState({
    id: props.data.id,
    clinic_id: props.data.clinic_id,
  });
  const formClinic = (data) => {
    let option = [];
    data.map((a) => {
      if (a.clinic.child.length > 0) {
        a.clinic.child.map((b) => {
          option.push({ id: b.clinic_id, name: b.name });
        });
      } else {
        option.push({ id: a.clinic.id, name: a.clinic.name });
      }
    });
    return option;
  };

  const updateLab = async () => {
    showLoading("Sedang Mengubah Data");
    if (visit.id > 0) {
      let res = await apiService.post(`registration/lab/send_wa`, {
        visit_id: visit.id,
      });
      if (res.code == 200) {
        toast({ status: "success", text: "berhasil" });
        props.onHide();
      } else {
        toast({ status: "error", text: "Gagal Mengubah Data" });
      }
    } else {
      toast({ status: "error", text: "data belum dipilih" });
    }
  };
  return (
    <div>
      <Modal {...props} aria-labelledby="modal-user">
        <ModalHeader closeButton>
          <ModalTitle>
            <h3>Informed Consent Pengiriman Data Via Whatsapp</h3>
          </ModalTitle>
        </ModalHeader>
        <Formik
          enableReinitialize
          initialValues={{
            ...visit,
          }}
          // validationSchema={SignupSchema}
          onSubmit={(values) => {
            updateLab();
          }}
        >
          {({ errors, touched }) => (
            <Form className="col-md-12">
              <ModalBody>
                Apakah pasien setuju hasil lab akan dikirim via Whatsapp?
              </ModalBody>
              <ModalFooter>
                <button
                  type="button"
                  onClick={() => {
                    props.onHide();
                  }}
                  className="btn btn-secondary"
                >
                  Tidak
                </button>
                <button type="submit" className="btn btn-primary">
                  Ya
                </button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

export default ModalWa;
